module.exports = __webpack_public_path__ + "img/logo-full-headline.e01a58bb.svg";